import { Alert, Button, Snackbar } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"
import { useMassOpsRunner } from "./useMassOpsRunner"

/**
 * Глобальное предупреждение «не закрывать вкладку» при активном батче.
 * Монтируется один раз в PrivateLayout. На самой странице /userbot/mass-ops
 * не показывается (там свой Alert сверху).
 */
export function MassOpsWarning() {
  const snapshot = useMassOpsRunner()
  const location = useLocation()
  const navigate = useNavigate()

  const open =
    snapshot.hasActive && !location.pathname.startsWith("/userbot/mass-ops")

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity="warning"
        variant="filled"
        icon={false}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => navigate("/userbot/mass-ops")}
          >
            Открыть
          </Button>
        }
      >
        Идут массовые операции — не закрывайте и не обновляйте вкладку
      </Alert>
    </Snackbar>
  )
}
